import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-start-monitoring",
  "use": "icon-start-monitoring-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-start-monitoring\"><path d=\"M21 12.75v3.75H3v-12h8.25V3H3a1.5 1.5 0 0 0-1.5 1.5v12A1.5 1.5 0 0 0 3 18h6v3H6v1.5h12V21h-3v-3h6a1.5 1.5 0 0 0 1.5-1.5v-3.75H21ZM13.5 21h-3v-3h3v3Z\" /><path d=\"M13.75 10.5v-9a.75.75 0 0 1 1.136-.643l7.5 4.5a.75.75 0 0 1 0 1.286l-7.5 4.5a.75.75 0 0 1-1.135-.643Zm1.5-7.676v6.351L20.544 6 15.25 2.824Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol